import React, { Component } from 'react'
import OnfsInput from './OnfsInput'
import OnfsSelect from './OnfsSelect'
import bootstrapScopedStyles from '../../styles/bootstrapScoped.min.module.css'
import OnfsCheckGroup from './OnfsCheckGroup'
import OnfsRadioGroup from './OnfsRadioGroup'
import OnfsButton from './../button/OnfsButton'
import OnfsFormGroup from './OnfsFormGroup'

class OnfsForm extends Component {
  state = {
    data: {},
    errors: {},
    wasSubmitted: false,
    preventSubmit: false
  }

  setPreventSubmit = (boolVal) => {
    this.setState({ ...this.state, preventSubmit: boolVal })
  }

  validate = (data) => {
    data = data || this.state.data

    const result = this.schema.validate(data)

    if (!result) {
      return null
    }
    const { error } = result
    if (!error || !error.details) {
      return null
    }
    const errors = {}

    for (const item of error.details) {
      errors[item.path[0]] = item.message || error.message
    }
    // TODO: we should handle all errors and either aggregate them or display them seperately
    // for (const path of item.path) {
    //   errors[path] = errors[path] || []
    //   errors[path].append(item.message || error.message)
    // }

    return errors
  }

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value }
    return this.validate({ ...this.state.data, ...obj })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const errors = this.validate()
    this.setState({ errors: errors || {}, wasSubmitted: true })
    if (errors) return

    if (!this.state.preventSubmit) {
      this.doSubmit()
    }
  }

  handleChange = (input) => {
    // const errors = { ...this.state.errors }
    // if (errorMessage) errors[input.name] = errorMessage
    // else delete errors[input.name]

    const data = { ...this.state.data }

    if (input.type?.toLowerCase() === 'checkbox') {
      data[input.name] = input.value?.toLowerCase() === 'true'
    } else {
      data[input.name] = input.value
    }

    const errors = this.validateProperty(input) || {}
    this.setState({ data, errors })
  }

  renderForm(children) {
    return (
      <div className={bootstrapScopedStyles['bootstrap-scope']}>
        <form onSubmit={this.handleSubmit}>{children}</form>
      </div>
    )
  }

  renderFormGroup({ name, label, description, children }) {
    return (
      <OnfsFormGroup name={name} label={label} description={description}>
        {children}
      </OnfsFormGroup>
    )
  }

  renderSubmitButton(label = 'Submit') {
    return <OnfsButton label={label} />
  }

  renderSelect({ name, label, options, placeholder, type, ...rest }) {
    const { data, errors } = this.state

    return (
      <OnfsSelect
        {...rest}
        name={name}
        value={data[name]}
        label={label}
        placeholder={placeholder}
        type={type}
        options={options}
        handleChange={this.handleChange}
        error={errors[name]}
        wasSubmitted={this.state.wasSubmitted}
      />
    )
  }

  renderInput({
    name,
    label,
    type = 'text',
    placeholder,
    style,
    defaultValue,
    ...rest
  }) {
    const { data, errors } = this.state

    return (
      <OnfsInput
        {...rest}
        type={type}
        defaultValue={defaultValue}
        name={name}
        value={data[name]}
        label={label}
        placeholder={placeholder}
        handleChange={this.handleChange}
        style={style}
        error={errors[name]}
        wasSubmitted={this.state.wasSubmitted}
      />
    )
  }

  renderCheckGroup({ label, children, style, ...rest }) {
    return (
      <OnfsCheckGroup
        label={label}
        children={children}
        style={style}
        setPreventSubmit={this.setPreventSubmit} // Used to show check group error (if requireOne is set)
        wasSubmitted={this.state.wasSubmitted}
        {...rest}
      />
    )
  }

  renderRadioGroup({ name, label, children, ...rest }) {
    const { errors } = this.state
    return (
      <OnfsRadioGroup
        name={name}
        label={label}
        children={children}
        handleChange={this.handleChange}
        error={errors[name]}
        // wasSubmitted={this.state.wasSubmitted}
        {...rest}
      />
    )
  }
}

export default OnfsForm
